import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, Sparkles } from "lucide-react";
import { useHubSpotForm } from "@/hooks/useHubSpotForm";

const STORAGE_KEY = "valubi_newsletter_popup_shown";

const PopupContent = ({ onClose }) => {
  useHubSpotForm({
    containerId: "newsletter-popup-form",
    portalId: "47937401",
    formId: "8133ea7b-48fe-4bae-948a-b59aab9e4b26"
  });

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95, y: 20 }}
      transition={{ duration: 0.25 }}
      className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto"
      onClick={(e) => e.stopPropagation()}
      data-testid="newsletter-popup">

      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors"
        aria-label="Luk"
        data-testid="newsletter-popup-close">

        <X size={20} />
      </button>

      <div className="p-6 sm:p-8">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-teal-50 border border-teal-100 rounded-full mb-4">
          <Sparkles className="text-teal-600" size={14} />
          <span className="text-teal-700 font-manrope font-semibold text-xs uppercase tracking-wider">
            Nyhedsbrev
          </span>
        </div>
        <h2 className="font-manrope font-bold text-2xl text-slate-900 mb-2">
          Få gratis Power BI templates
        </h2>
        <p className="text-slate-600 text-sm mb-6">
          Tilmeld dig nyhedsbrevet og få vores Power BI templates til
          Business Central og e-conomic. Nyhedsbrevet kommer sjældent,
          og du kan afmelde med ét klik.
        </p>
        <div id="newsletter-popup-form" className="min-h-[240px]" data-testid="newsletter-popup-hubspot-form" />
      </div>
    </motion.div>);

};

const NewsletterPopup = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const isTemplatesPage = location.pathname === "/skabeloner";

  useEffect(() => {
    if (isTemplatesPage) return;
    if (localStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => {
      localStorage.setItem(STORAGE_KEY, "true");
      setShow(true);
    }, 7000);
    return () => clearTimeout(timer);
  }, [isTemplatesPage]);

  const handleClose = () => setShow(false);

  return (
    <AnimatePresence>
      {show &&
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm"
        onClick={handleClose}
        data-testid="newsletter-popup-overlay">

          <PopupContent onClose={handleClose} />
        </motion.div>
      }
    </AnimatePresence>);

};

export default NewsletterPopup;
